export const emailTopicsMappingToBreadcrumbsAndSolutionTags = {
  deliveryQuery: {
    breadcrumb: "deliveryQueries",
    solutionTag: "deliveryQueries-trackMyOrder",
  },
  returns: {
    breadcrumb: "returnsAndRefunds-returning",
    solutionTag: "returnsAndRefunds-returningOrExchanging",
  },
  refunds: {
    breadcrumb: "returnsAndRefunds-refunds",
    solutionTag: "returnsAndRefunds-refunds-refundsJL",
  },
  problemsWithProduct: {
    breadcrumb: "problemsWithProduct-other",
    solutionTag: "problemsWithProduct-other",
  },
  productAndStockInformation: {
    breadcrumb: "productStockInformation",
    solutionTag: "productStockInformation-productStockInformationOutStock",
  },
  orderQuery: {
    breadcrumb: "placeEditCancelOrder",
    solutionTag: "placeEditCancelOrder",
  },
  myJLMembership: {
    breadcrumb: "myJLMembership",
    solutionTag: "myJLMembership",
  },
};
